{
  "type": "object",
  "name": "ProduktionsauftragQuery",
  "class": "g gap gtc-1 gtc-m-2 gr-2 gr-m-1",
  "definitions": [
    {
      "type": "date",
      "class": "gc-1 gr-1",
      "name": "von_datum",
      "title": "Von Datum",
      "required": true
    },
    {
      "type": "date",
      "class": "gc-1 gr-2 gc-m-2 gr-m-1",
      "name": "bis_datum",
      "title": "Bis Datum",
      "required": true
    }
  ]
}
